export default __webpack_public_path__ + "static/media/SqoutLogo.1e7838a3.svg";